import './src/styles/global.css';
import './src/styles/global.scss';
import './src/styles/typography.scss';
import './src/styles/buttons.scss';
import './src/styles/footer.scss';
import browserHydrateFunction from './src/utilities/gatsby/browser-hydrate-function';
import ErrorModal from './src/components/ui/modal/ErrorModal';
import React from 'react';
import { fetchAppVersion, isBrowser } from './src/helper/helpers';
import InvoiceApiErrorModal from './src/components/ui/modal/InvoiceApiErrorModal';
import { SESSION_STORAGE_NAME } from './src/constants/enum';
export const replaceHydrateFunction = browserHydrateFunction;
export const onRouteUpdate = ({ location }) => {
  if (location.hash || location.search) return;
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 200);
};
fetchAppVersion();
export const wrapPageElement = ({ element }) => {
  return (
    <>
      <ErrorModal />
      <InvoiceApiErrorModal />
      {element}
    </>
  );
};
export const onInitialClientRender = () => {
  if (isBrowser) {
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = urlParams.get(SESSION_STORAGE_NAME?.REFERRER);

    if (referrer) {
      sessionStorage.setItem(SESSION_STORAGE_NAME?.REFERRER, referrer);
    }
  }
};

export { default as wrapRootElement } from './src/state/reduxWrapper';
